export const Devider=()=>{
    return(
        <div className="devider"></div>
    )
}